import React from "react";

export const addClassToPopup = () => {
  const popupElement = document.querySelector(".mapboxgl-popup-content");
  if (popupElement) {
    popupElement.classList.add("mapboxgl-popup-content-big");
  }
};

export const removeClassToPopup = () => {
  const popupElement = document.querySelector(".mapboxgl-popup-content");
  if (popupElement) {
    popupElement.classList.remove("mapboxgl-popup-content-big");
  }
};

export function check_tsi_wsi(d) {
  let labelId = "TSI";
  if (d.value.includes("-")) {
    labelId = "WSI";
  }
  return (
    <li key={labelId}>
      {labelId}: {d.value}
    </li>
  );
}

export function getLabelID(data, isInOscar) {
  if (isInOscar) {
    return "WSI";
  }
  return "TSI";
}

export function getWigosLabelID(stationName, wigosid) {
  let labelID = "WIGOS-ID";
  if (stationName === "Unknown") {
    labelID = "TSI";
    if (wigosid.includes("-")) {
      labelID = "WSI";
    }
  }
  return labelID;
}

export function renderOSCARLink(inOscar, wigosid, LinkOSCAR) {
  if (!inOscar) {
    return (
      <a
        className="isDisabled link-oscar"
        target="_blank"
        rel="noopener noreferrer"
        href="#"
        onClick={e => e.preventDefault()}
      >
        Open in OSCAR
      </a>
    );
  }
  return <LinkOSCAR wigosid={wigosid} />;
}

export function buildDataTable(data, reportType) {
  if (reportType !== "gts-to-wis2") {
    return null;
  }

  const tableTitle = (
    <>
      <br />
      Received by source and encoding
    </>
  );

  const tableStyle = {
    marginTop: "10px",
    borderCollapse: "collapse",
    width: "100%"
  };

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "8px"
  };

  const headerCellStyle = {
    ...cellStyle,
    textAlign: "center"
  };

  const bodyCellStyle = {
    ...cellStyle,
    textAlign: "center"
  };

  const labelCellStyle = {
    ...cellStyle,
    fontWeight: "bold"
  };

  return {
    title: tableTitle,
    table: (
      <table className="popup-data-table" style={tableStyle}>
        <thead>
          <tr>
            <th style={cellStyle}></th>
            <th style={headerCellStyle}>TAC</th>
            <th style={headerCellStyle}>BUFR</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={labelCellStyle}>GTS</td>
            <td style={bodyCellStyle}>{data.gts_tac_nr_received}</td>
            <td style={bodyCellStyle}>{data.gts_bufr_nr_received}</td>
          </tr>
          <tr>
            <td style={labelCellStyle}>WIS2</td>
            <td style={bodyCellStyle}>{data.wis2_tac_nr_received}</td>
            <td style={bodyCellStyle}>{data.wis2_bufr_nr_received}</td>
          </tr>
        </tbody>
      </table>
    )
  };
}

export function buildTempDataTable(data) {
  const tableStyle = {
    marginTop: "10px",
    borderCollapse: "collapse",
    width: "100%"
  };

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "8px"
  };

  const headerCellStyle = {
    ...cellStyle,
    textAlign: "center"
  };

  const bodyCellStyle = {
    ...cellStyle,
    textAlign: "center"
  };

  const labelCellStyle = {
    ...cellStyle,
    fontWeight: "bold"
  };

  return (
    <table className="popup-data-table" style={tableStyle}>
      <thead>
        <tr>
          <th style={cellStyle}></th>
          <th style={headerCellStyle}>BUFR</th>
          <th style={headerCellStyle}>TAC</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={labelCellStyle}>GTS</td>
          <td style={bodyCellStyle}>{data.gts_bufr_nr_received}</td>
          <td style={bodyCellStyle}>{data.gts_tac_nr_received}</td>
        </tr>
        <tr>
          <td style={labelCellStyle}>WIS2</td>
          <td style={bodyCellStyle}>{data.wis2_bufr_nr_received}</td>
          <td style={bodyCellStyle}>{data.wis2_tac_nr_received}</td>
        </tr>
      </tbody>
    </table>
  );
}

export function groupCenterValues(centersValues) {
  let groupedCenters = [];
  let currentCenter = null;

  centersValues.forEach(item => {
    if (item.type === "title") {
      currentCenter = { center: item.value, values: [] };
      groupedCenters.push(currentCenter);
    } else if (item.type === "value") {
      if (currentCenter) {
        currentCenter.values.push(item);
      }
    }
  });

  return groupedCenters;
}

export function renderGroupedCenters(groupedCenters) {
  return groupedCenters.map(center => {
    return (
      <li key={center.center}>
        <b>{center.center}</b>
        <ul>
          {center.values.map(val => {
            let classElement = val.highlight ? "popup-value-highlighted" : "";
            return (
              <li
                key={`${val.value}-${Math.random()}`}
                className={classElement}
              >
                {val.value}
              </li>
            );
          })}
        </ul>
      </li>
    );
  });
}

export function renderCenterValues(centersValues) {
  return centersValues.map(k => {
    let classElement;
    if (k.type === "title") {
      classElement = "popup-title-center";
    }
    if (k.highlight) {
      classElement = "popup-value-highlighted";
    }
    return (
      <li key={k.value} className={classElement}>
        {k.value}
      </li>
    );
  });
}

export function processQualityMetrics(element, selectedVariable, props, multiplier) {
  const metrics = {};

  if (!props.combinedMode) {
    let avg_bg_dep = element.avg_bg_dep;
    if (selectedVariable === "58") {
      avg_bg_dep *= 100;
    }
    avg_bg_dep = (avg_bg_dep / 1).toFixed(2);
    if (element.avg_bg_dep === null || element.avg_bg_dep === undefined) {
      avg_bg_dep = "No Data";
    }
    metrics.avg_bg_dep = avg_bg_dep;

    let std_bg_dep = element.std_bg_dep;
    if (selectedVariable === "58") {
      std_bg_dep *= 100;
    }
    std_bg_dep = (std_bg_dep / 1).toFixed(2);
    if (element.std_bg_dep === null || element.std_bg_dep === undefined) {
      std_bg_dep = "No Data";
    }
    metrics.std_bg_dep = std_bg_dep;
  }

  const toHighlight =
    Math.round(element.rms * 100000) / 100000 ===
    Math.round(props.stationObject.rms * 100000) / 100000;

  let rms = element.rms;
  if (selectedVariable === "58") {
    rms *= 100;
  }
  rms = (rms / 1).toFixed(2);
  if (element.rms === null || element.rms === undefined) {
    rms = "No Data";
  }
  metrics.rms = rms;
  metrics.toHighlight = toHighlight;

  if (props.combinedMode) {
    let gross_error_percent = element.gross_error_percent;
    if (
      isNaN(gross_error_percent) ||
      gross_error_percent === null ||
      gross_error_percent === undefined
    ) {
      gross_error_percent = "No data";
    } else {
      gross_error_percent = gross_error_percent.toFixed(2);
    }
    metrics.gross_error_percent = gross_error_percent;
  }

  return metrics;
}
